export default "__VITE_ASSET__CC7YYFR1__"